// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"8b69f6ec","27":"cf1ba137","206":"5a0ab72c","357":"74315ab2","379":"6c16ab04"}[chunkId] + ".css";
};